// Lógica do Simulador de impacto tributário da Lei do Salão Parceiro.
// Fonte das regras: documento "Calculadora de Impostos - Vitaminaweb", fornecido pela Contabeleza
// (mesma lógica da calculadora oficial em calculadora.contabeleza.com.br).
// Pendente de validação final pelo time contábil antes da publicação.

// Tabela do Simples Nacional, Anexo III (serviços de salões de beleza e afins)
const ANEXO_III = [
    { limiteAnual: 180000, aliquota: 0.06, deduzir: 0 },
    { limiteAnual: 360000, aliquota: 0.112, deduzir: 9360 },
    { limiteAnual: 720000, aliquota: 0.135, deduzir: 17640 },
    { limiteAnual: 1800000, aliquota: 0.16, deduzir: 35640 },
    { limiteAnual: 3600000, aliquota: 0.21, deduzir: 125640 },
    { limiteAnual: 4800000, aliquota: 0.33, deduzir: 648000 },
];

export const COMISSAO_MIN = 30;
export const COMISSAO_MAX = 70;
export const COMISSAO_PADRAO = 50;
export const LIMITE_SIMPLES_ANUAL = 4800000;

export const PREMISSAS = [
    "Salão enquadrado no Simples Nacional, Anexo III, como na calculadora oficial da Contabeleza.",
    "A faixa de tributação é definida pela receita bruta dos últimos 12 meses (aqui estimada como faturamento mensal informado × 12).",
    "No cenário com parceria, as comissões dos profissionais parceiros, emitidas em nota fiscal contra o salão, são deduzidas da base de cálculo, conforme a Lei nº 13.352/2016.",
    "O percentual de comissão é configurável (padrão de mercado: 50%).",
    "O resultado é uma estimativa com finalidade didática, sem caráter de orientação tributária individual.",
];

export const formatBRL = (valor) =>
    new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
        Number.isFinite(valor) ? valor : 0
    );

export const formatPct = (valor) =>
    `${new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(valor)}%`;

function calcularSimples(receitaAnual) {
    const index = ANEXO_III.findIndex((f) => receitaAnual <= f.limiteAnual);
    if (index === -1) return null;
    const faixa = ANEXO_III[index];
    const impostoAnual = Math.max(receitaAnual * faixa.aliquota - faixa.deduzir, 0);
    return {
        faixa: index + 1,
        aliquotaNominal: faixa.aliquota * 100,
        parcelaDeduzir: faixa.deduzir,
        impostoAnual,
        impostoMensal: impostoAnual / 12,
        aliquotaEfetiva: receitaAnual > 0 ? (impostoAnual / receitaAnual) * 100 : 0,
    };
}

const clamp = (n, min, max) => Math.min(Math.max(Number(n) || 0, min), max);

export function simular({ faturamento, percentualParceiros }) {
    const fat = Math.max(Number(faturamento) || 0, 0);
    const pct = clamp(percentualParceiros, COMISSAO_MIN, COMISSAO_MAX) / 100;

    const acimaDoLimite = fat * 12 > LIMITE_SIMPLES_ANUAL;
    const semLei = calcularSimples(fat * 12);
    const baseParceriaMensal = fat * (1 - pct);
    const comLei = calcularSimples(baseParceriaMensal * 12);

    const diferencaMensal = semLei && comLei ? semLei.impostoMensal - comLei.impostoMensal : 0;

    return {
        faturamento: fat,
        percentualParceiros: pct * 100,
        parteParceiros: fat * pct,
        baseParceriaMensal,
        semLei,
        comLei,
        diferencaMensal,
        diferencaAnual: diferencaMensal * 12,
        acimaDoLimite,
        valido: fat > 0 && !acimaDoLimite && Boolean(semLei && comLei),
    };
}
